'use strict';
import * as $j_app$002edata$002e$002dUser$002dKind$0024$002dViewer from "./app.data.-User-Kind$-Viewer.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserKind$Viewer$() {
}
export { $c_Lapp_data_UserKind$Viewer$ as $c_Lapp_data_UserKind$Viewer$ };
$p = $c_Lapp_data_UserKind$Viewer$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_UserKind$Viewer$;
/** @constructor */
function $h_Lapp_data_UserKind$Viewer$() {
}
export { $h_Lapp_data_UserKind$Viewer$ as $h_Lapp_data_UserKind$Viewer$ };
$h_Lapp_data_UserKind$Viewer$.prototype = $p;
$p.n = (function() {
  return "Viewer";
});
$p.bL4 = (function(x$0) {
  return new $j_app$002edata$002e$002dUser$002dKind$0024$002dViewer.$c_Lapp_data_UserKind$Viewer(x$0.e(0));
});
$p.U = (function(p) {
  return this.bL4(p);
});
var $d_Lapp_data_UserKind$Viewer$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserKind$Viewer$, "app.data.UserKind$Viewer$", ({
  Fs: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_UserKind$Viewer$ as $d_Lapp_data_UserKind$Viewer$ };
var $n_Lapp_data_UserKind$Viewer$;
function $m_Lapp_data_UserKind$Viewer$() {
  if ((!$n_Lapp_data_UserKind$Viewer$)) {
    $n_Lapp_data_UserKind$Viewer$ = new $c_Lapp_data_UserKind$Viewer$();
  }
  return $n_Lapp_data_UserKind$Viewer$;
}
export { $m_Lapp_data_UserKind$Viewer$ as $m_Lapp_data_UserKind$Viewer$ };
//# sourceMappingURL=app.data.-User-Kind$-Viewer$.js.map
